<script>
import bankListJSON from '@/assets/data/bankList.json';
import { gender, maritalStatus } from "@/assets/data/optionData.js"
import provinceListJSON from "@/assets/data/province.json"
// eslint-disable-next-line no-unused-vars
import { ValidateUtil } from "@/plugins/app-util.js";
import cityListJSON from "@/assets/data/cityList.json"
import DesignInput from '@/components/design-system/design-input.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import EditIcon from '@/components/design-system/icon/edit.vue';

export default {
    emits: ["afterSave", "editing-change"],
    computed: {
        hasChange() {
            if (!this.nowEdit) return false;
            return JSON.stringify(this.request) !== JSON.stringify(this.beforeEditData);
        },
    },
    watch: {
        hasChange(val) {
            this.$emit('editing-change', val);
        },
    },
    props: {
        selectedEmployeeSeq : String,
    },
    components:{
        DesignInput,
        DesignButton,
        DesignDropdownSelect,
        EditIcon,
    },
    data() {
        return {
            showNoti : false,
            showNotiErr : false,
            nowEdit: false,
            showEditBtn: false,
            phoneNumberPrepend: "+63",
            nationalityOptions: [
                {
                    text: "Philippines",
                    value: "philippines",
                }
            ],
            provinceOptions : [],
            cityListOptions : [],
            genderOptions: gender,
            maritalStatusOptions: maritalStatus,
            bankAccountOptions: [],
            beforeEditData : {},
            directInputBankName:null,
            request : {
                firstName: null,
                middleName: null,
                lastName: null,
                employeeName: null,
                nickName: null,
                phoneNumber: null,
                email: null,
                birthday: null,
                gender: null,
                maritalStatus: null,
                nationality: null,
                // tinNo: null,
                passportNo: null,
                city: null,
                province: null,
                street: null,
                addr1: null,
                addr2: null,
                zipCode: null,
                // bankName: null,
                // bankAccountNumber: null,
                emergencyContactName: null,
                emergencyContactRelationship: null,
                emergencyContactPhoneNumber: null,
                workSchedule : null,
            },
            requestErrorMsg: {
                firstName: "First Name can't be blank",
                lastName: "Last Name can't be blank",
                phoneNumber: "Please enter a valid 10-digit mobile number.",
                zipCode : "Make sure you enter valid Zipcode",
            },
            requestError: {
                firstName: null,
                lastName: null,
                phoneNumber: null,
                emergencyContactPhoneNumber: null,
                zipCode : null,
            },
        }; //return
    }, //data
    mounted(){
        const self = this;
        self.getBasicOptions();
        self.getBasicInfo();
    },
    methods:{
        getBasicOptions(){
            const self = this;
            self.bankAccountOptions = bankListJSON
                .sort((a,b)=>(a).localeCompare(b))
                .map(bank => ({ "text" : bank, "value": bank.split(" ").join('_').toUpperCase()}))
            self.bankAccountOptions.unshift({"text" : "Direct input", "value" : "DIRECT_INPUT"})
            self.provinceOptions = provinceListJSON
                .sort((a,b)=>(a.text).localeCompare(b.text))
                .map(province => ({ "text" : province.text, "value": province.text}))
        },
        setBasicInfoFromDB(dbData){
            const self = this;
            let { firstName, middleName, lastName ,employeeName ,nickName ,phoneNumber ,email ,birthday ,gender ,maritalStatus
                ,nationality  ,city ,province ,street ,addr1 ,addr2 ,zipCode
                /* ,bankName ,bankAccountNumber ,tinNo */ ,emergencyContactName ,emergencyContactRelationship ,emergencyContactPhoneNumber } = dbData;


            // phoneNumber = ValidateUtil.convertPhoneGlobalToLocal(phoneNumber);
            // emergencyContactPhoneNumber = ValidateUtil.convertPhoneGlobalToLocal(emergencyContactPhoneNumber)
            // self.directInputBankName = null;
            // if( bankName && bankName.startsWith("DI_") ){
            //     self.directInputBankName = bankName.replace("DI_","");
            //     bankName = "DIRECT_INPUT"
            // }

            return { firstName, middleName, lastName ,employeeName ,nickName ,phoneNumber ,email ,birthday ,gender ,maritalStatus
            ,nationality ,city ,province ,street ,addr1 ,addr2 ,zipCode
            /* ,bankName ,bankAccountNumber ,tinNo*/ ,emergencyContactName ,emergencyContactRelationship ,emergencyContactPhoneNumber };
        },
        getCityOptions( city = null ){
            const self = this;
            self.request.city = null;
            if(!self.request.province ) return;
            self.cityListOptions = cityListJSON[self.request.province]
                .map(city => ({text : city, value : city }))
            self.request.city = city;

        },
        getBasicInfo(){
            const self = this;
            const url = self.$api("uri", `get-employee-basic-info`).replace("{employeeSeq}", encodeURIComponent(self.selectedEmployeeSeq));
            self.$axios.get(url).then((res) => {
                self.request = self.setBasicInfoFromDB(res.data.data)
                self.getCityOptions(res.data.data.city);

                self.showEditBtn=true;
            }).catch(err=>self.showEditBtn=false)
        },
        editButtonClick(){
            const self = this;

            self.beforeEditData = { ...self.request };
            self.nowEdit = true;
        },
        cancelEditJBasicInfo() {
            const self = this;

            self.request = { ...self.beforeEditData };
            if(self.request.bankName != "DIRECT_INPUT" ) self.directInputBankName = null;
            self.nowEdit = false;
            self.errMsgReset();
        },
        getDataForSave(){
            const self = this;

            const saveData = { ...self.request };
            delete saveData.email;
            delete saveData.workSchedule;

            // if(saveData.bankName == "DIRECT_INPUT") saveData.bankName = "DI_" + self.directInputBankName;
            // self.directInputBankName = null;

            for( let key in saveData ){
                if ( ValidateUtil.checkIsEmpty( saveData[key] ) ) saveData[key] = null;
                if( !saveData[key]) continue;
                saveData[key] = saveData[key].trim();
                if ( ValidateUtil.checkIsEmpty( saveData[key] ) ) saveData[key] = null;
            }

            saveData.employeeName = ValidateUtil.employeeNameSave( saveData.firstName, saveData.middleName, saveData.lastName );
            saveData.phoneNumber = ValidateUtil.removeCountryCodePhoneNumber(saveData.phoneNumber);
            if( !ValidateUtil.checkIsEmpty(saveData.emergencyContactPhoneNumber) ){
                saveData.emergencyContactPhoneNumber = ValidateUtil.removeCountryCodePhoneNumber(saveData.emergencyContactPhoneNumber)
            }

            return saveData;
        },
        saveBasicInfo() {
            const self = this;
            const url = self.$api('uri', 'put-employee-basic-info');

            self.errMsgReset();
            if(!self.isValidCheck()) {
                self.showNotiErr = true;
                return;
            }

            const saveData = self.getDataForSave();
            self.$axios.put(`${url}/${encodeURIComponent(self.selectedEmployeeSeq)}`, saveData)
            .then( res => {
                console.log(' basic info post ', res.data);
                self.nowEdit = false;
                self.showNoti = true;
                self.$emit('afterSave');
                self.getBasicInfo();
            }).catch(err => {
                console.error('basic info error => ', err)
                const code = err?.response?.data?.code || '';
                if (code === 'API_WARN_BAD_REQUEST_WHILE_CONVERT') {
                    self.requestError.emergencyContactPhoneNumber = self.requestErrorMsg.phoneNumber;
                }
                self.showNotiErr = true;
            })
        },
        isValidCheck(){
            const self =this;
            let isValid = true;

            if(ValidateUtil.checkIsEmpty(self.request.firstName)){
                self.requestError.firstName = self.requestErrorMsg.firstName;
                isValid = false;
            }
            if(ValidateUtil.checkIsEmpty(self.request.lastName)){
                self.requestError.lastName = self.requestErrorMsg.lastName;
                isValid = false;
            }

            const normalizedNumber =  ValidateUtil.removeCountryCodePhoneNumber(self.request.phoneNumber);
            if(ValidateUtil.invalidPhoneNumber(normalizedNumber)){
                self.requestError.phoneNumber = self.requestErrorMsg.phoneNumber;
                isValid = false;
            }
            if(!ValidateUtil.checkIsEmpty(self.request.emergencyContactPhoneNumber)) {
                if(ValidateUtil.invalidPhoneNumber(self.request.emergencyContactPhoneNumber)){
                    self.requestError.emergencyContactPhoneNumber = self.requestErrorMsg.phoneNumber;
                    isValid = false;
                }
            }
            if(!ValidateUtil.checkIsEmpty(self.request.zipCode) && !ValidateUtil.checkZipcode(self.request.zipCode)){
                self.requestError.zipCode = self.requestErrorMsg.zipCode;
                isValid = false;
            }

            return isValid;
        },
        errMsgReset(){
            const self = this;
            for( let errMsgKey in self.requestError){
                self.requestError[errMsgKey] = '';
            }
        },
    },

};
</script>

<template>
<div class="">
    <div class="sticky top-0 w-[100%] pt-3 pb-4 bg-white" style="z-index:100">
        <div class="flex justify-between items-center">
            <h4 class="font-heading-sm-semibold">
                Basic Information
            </h4>
             <DesignButton
                v-show="$appUtil.checkPermission('BASIC_INFO_EDIT') && !nowEdit && showEditBtn"
                btnText="Edit"
                btnSize="SM"
                btnType="PRIMARY"
                btnVariant="BORDER"
                :btnDisabled="false"
                @click="editButtonClick"
            >
                <template #front-icon>
                    <EditIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                </template>
            </DesignButton>
             <div class="flex justify-end items-center gap-2" v-show="nowEdit">
                <DesignButton
                    @click="cancelEditJBasicInfo"
                    btnText="Cancel" btnSize="SM" btnType="SECONDARY" btnVariant="BORDER" class="w-[64px]" :btnDisabled="false"
                />
                <DesignButton
                    @click="saveBasicInfo"
                    btnText="Save" btnSize="SM" btnType="PRIMARY" btnVariant="FILL" class="w-[64px]" :btnDisabled="false"
                />
            </div>
        </div>
        <p
                v-show="nowEdit"
                class="font-body-sm-regular text-accent-red-3"
            >
                You are in the editing mode now. Please click the save button.
            </p>
    </div>

    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">First Name</div>
        <DesignInput
            v-model="request.firstName"
            placeholder="Enter First Name"
            class="flex-1"
            :disabled="!nowEdit"
            :maxlength="60"
            :error="requestError.firstName"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Middle Name</div>
        <DesignInput
            v-model="request.middleName"
            placeholder="Enter Middle Name"
            class="flex-1"
            :disabled="!nowEdit"
            :maxlength="60"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Last Name</div>
        <DesignInput
            v-model="request.lastName"
            placeholder="Enter Last Name"
            class="flex-1"
            :disabled="!nowEdit"
            :maxlength="60"
            :error="requestError.lastName"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Nick Name</div>
        <DesignInput
            v-model="request.nickName"
            placeholder="Enter Nick Name"
            class="flex-1"
            :disabled="!nowEdit"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4 ">
        <div class="c_label w-[8rem] flex-shrink-0">
            Phone Number
        </div>
        <div class="flex gap-2 w-full">
            <DesignInput
                :width="'w-[6rem]'"
                v-model="phoneNumberPrepend"
                :disabled="true"
            />
            <DesignInput
                v-model="request.phoneNumber"
                placeholder="Enter Phone Number"
                class="flex-1"
                :disabled="!nowEdit"
                :full="true"
                :error="requestError.phoneNumber"
                :maxlength="12"
                :isPhoneNum="true"
            />
        </div>
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Work Email</div>
        <DesignInput
            v-model="request.email"
            class="flex-1"
            :disabled="true"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Birthday</div>
        <ElementsDatePicker
            v-model="request.birthday"
            class="flex-1"
            :disabled="!nowEdit"
            :full="true"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Gender</div>
        <DesignDropdownSelect
            v-model="request.gender"
            placeholder="Select Gender"
            class="flex-1"
            :width="'w-full'"
            :readonly="!nowEdit"
            :options="genderOptions"
            :useDefaultMsg="true"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">
            Marital status
        </div>
        <DesignDropdownSelect
            v-model="request.maritalStatus"
            placeholder="Select Marital status"
            class="flex-1"
            :width="'w-full'"
            :readonly="!nowEdit"
            :options="maritalStatusOptions"
            :full="true"
            :useDefaultMsg="true"
        />
    </div>
    <div class="flex justify-between items-center gap-2 mt-4">
        <div class="c_label w-[8rem]">Nationality</div>
        <DesignDropdownSelect
            v-model="request.nationality"
            placeholder="Select Nationality"
            class="flex-1"
            :width="'w-full'"
            :readonly="!nowEdit"
            :options="nationalityOptions"
            :full="true"
        />
    </div>
    <!-- <div class="flex justify-between items-center gap-2 mt-6">
        <div class="w-32 text-sm font-semibold text-slate-800">TIN No.</div>
        <ElementsInput
            v-model="request.tinNo"
            placeholder="Enter TIN No."
            class="flex-1"
            :disabled="!nowEdit"
            :full="true"
        />
    </div> -->
    <div class="flex justify-between gap-2 mt-4">
        <div class="c_label w-[8rem] h-[2.75rem] flex items-center">
            Home Address
        </div>
        <div class="flex flex-col gap-2 flex-1">
            <DesignInput
                v-model="request.addr1"
                placeholder="Unit / Lot / Bldg Number"
                class="flex-1"
                :disabled="!nowEdit"
            />
            <DesignInput
                v-model="request.street"
                placeholder="Street / Barangay"
                class="flex-1"
                :disabled="!nowEdit"
            />
            <DesignDropdownSelect
                v-model="request.province"
                placeholder="Select Province"
                class="flex-1"
                :width="'w-full'"
                :readonly="!nowEdit"
                :useDefaultMsg="true"
                :options="provinceOptions"
                @change="getCityOptions"
            />
            <DesignDropdownSelect
                v-model="request.city"
                class="flex-1"
                :width="'w-full'"
                :placeholder="'Select City/Municipality'"
                :useDefaultMsg="true"
                :readonly="!nowEdit"
                :options="cityListOptions"
            />
            <DesignInput
                v-model="request.zipCode"
                placeholder="Zip Code"
                class="flex-1"
                :disabled="!nowEdit"
                :error="requestError.zipCode"
            />
        </div>
    </div>
    <!-- <div class="flex justify-between items-center gap-2 mt-6 max-w-7xl">
        <div class="w-32 text-sm font-semibold text-slate-800">
            Bank account
        </div>
        <div class="flex flex-1 gap-2">
            <ElementsSelectRef
                v-model="request.bankName"
                placeholder="Select Bank"
                class="flex-1"
                :readonly="!nowEdit"
                :options="bankAccountOptions"
                :full="true"
                :useDefaultMsg="true"
            />
            <ElementsInput
                v-show="request.bankName == 'DIRECT_INPUT'"
                v-model="directInputBankName"
                placeholder="Enter Bank name"
                class="flex-1"
                :readonly="!nowEdit"
                :full="true"
                :maxlength="40"
            />
        </div>
    </div>
    <div class="flex justify-between items-center gap-2 mt-6">
        <div class="w-32 text-sm font-semibold text-slate-800">
            Account Number
        </div>
        <ElementsInput
            v-model="request.bankAccountNumber"
            placeholder="Enter Account Number"
            class="flex-1"
            :disabled="!nowEdit"
            :full="true"
            :maxlength="40"
        />
    </div> -->
    <div class="flex justify-between gap-2 mt-4">
        <div class="c_label w-[8rem] h-[2.75rem] flex items-cente">
            Emergency Contact
        </div>
        <div class="flex flex-col gap-2 flex-1">
            <DesignInput
                v-model="request.emergencyContactName"
                placeholder="Enter Name"
                class="flex-1"
                :disabled="!nowEdit"
                :full="true"
            />
            <DesignInput
                v-model="request.emergencyContactRelationship"
                placeholder="Enter Relationship"
                class="flex-1"
                :disabled="!nowEdit"
                :full="true"
                :maxlength="40"
            />
            <div class="flex gap-2">
                <DesignInput
                    v-model="phoneNumberPrepend"
                    :disabled="true"
                    :width="'w-[6rem]'"
                />
                <DesignInput
                    v-model="request.emergencyContactPhoneNumber"
                    placeholder="Enter Phone Number"
                    class="flex-1"
                    :disabled="!nowEdit"
                    :full="true"
                    :error="requestError.emergencyContactPhoneNumber"
                    :maxlength="12"
                    :isPhoneNum="true"
                />
            </div>
        </div>
    </div>
    <ElementsNotification
        v-model="showNoti"
    />
    <ElementsNotification
        v-model="showNotiErr"
        :notificationMsg="'Please check the error message'"
        :warning="true"
    />
</div>

</template>
